module.exports = __webpack_public_path__ + "static/quizbaker5-ed3061dd20c4b302bf06e7a3f6d311ae.png";